import type { InjectionKey, Ref } from 'vue';
import { createInjectionState, reactifyObject } from '@vueuse/core';
import type { EditorProductProperty } from '@getaccept/editor-lib/src/types/editor-product-property';

export const EDITOR_VIEW_STATE_KEY = Symbol() as InjectionKey<EditorViewState>;

export type EditorViewState = {
  productProperties: Ref<EditorProductProperty[]>;
};

const [useProvideEditorViewState, _useInjectEditorViewState] = createInjectionState(
  (state: EditorViewState) => reactifyObject(state),
  { injectionKey: EDITOR_VIEW_STATE_KEY }
);

function useInjectEditorViewState() {
  const editorViewState = _useInjectEditorViewState();

  if (editorViewState == null)
    throw new Error('Please call `useProvideEditorViewState` in the EditorViewBlock component');

  return editorViewState;
}

export { useProvideEditorViewState, useInjectEditorViewState };
